import { PageHeader } from 'components/page-header';
import { AddStructureGridsCollectionForm } from './structure-grids-collection-form';

export const AddStructureGridsCollection = () => {
  return (
    <>
      <PageHeader
        title="Add New Structure Grid Collection"
        breadcrumbs={[
          ['/structure_grids', 'Structure Grid Management'],
          ['/structure_grid_collections', 'Structure Grid Collections'],
          ['/structure_grid_collections/new', 'Add Structure Grid Collection'],
        ]}
        actions={null}
      ></PageHeader>
      <AddStructureGridsCollectionForm />
    </>
  );
};
